import _ from "lodash";
import BaseListTileView from "scripts/views/baseListTileView";
import templateArticleListTile from "templates/articleListTile.hbs";

class ArticleListTileView extends BaseListTileView {
  get template() {
    return templateArticleListTile;
  }

  get events() {
    return _.extend({}, super.events, {
      "click .btn-bookshelf": "onClickBookshelfButton",
    });
  }

  constructor(options) {
    super(options);

    if (this.bookshelfAvailable()) {
      this.initializeBookshelfDeps();
    }
  }

  render() {
    super.render();

    if (this.bookshelfAvailable()) {
      this.renderBookshelfElements();
    }

    return this;
  }
}

export default ArticleListTileView;
